import { Controller } from "@hotwired/stimulus";

// The sentence under the bed release fields on facility settings: what the
// chosen policy does, with the night count written into it, so the two
// fields read as one rule. Every policy's sentence sits in the DOM and the
// others are hidden; the count is written into the `nights` spans as it is
// typed. Tom Select fires the native change event on the select it wraps.
//
//   <div data-controller="bed-release-explainer"
//        data-bed-release-explainer-one-value="night" data-bed-release-explainer-other-value="nights"
//        data-bed-release-explainer-fallback-value="that many nights">
//     <select data-bed-release-explainer-target="policy" data-action="change->bed-release-explainer#update">…</select>
//     <input type="number" data-bed-release-explainer-target="count" data-action="input->bed-release-explainer#update">
//     <p data-bed-release-explainer-target="hint" data-policy="auto_release" hidden>
//       After <span data-bed-release-explainer-target="nights">3 nights</span> in a row…
//     </p>
//   </div>
export default class extends Controller {
  static targets = ["policy", "count", "hint", "nights"];
  static values = { one: String, other: String, fallback: String };

  declare readonly policyTarget: HTMLSelectElement;
  declare readonly countTarget: HTMLInputElement;
  declare readonly hintTargets: HTMLElement[];
  declare readonly nightsTargets: HTMLElement[];
  declare oneValue: string;
  declare otherValue: string;
  declare fallbackValue: string;

  connect() {
    this.update();
  }

  update() {
    const policy = this.policyTarget.value;
    const nights = this.nights();

    this.nightsTargets.forEach((span) => {
      span.textContent = nights;
    });
    this.hintTargets.forEach((hint) => {
      hint.hidden = hint.dataset.policy !== policy;
    });
  }

  // "3 nights"; while the field is blank or nonsense the sentence still reads.
  private nights(): string {
    const count = Number(this.countTarget.value);
    if (!Number.isInteger(count) || count < 1) return this.fallbackValue;

    return `${count} ${count === 1 ? this.oneValue : this.otherValue}`;
  }
}
